export default "__VITE_ASSET__4e463659__"